import React from 'react';
import { observer } from 'mobx-react-lite';

import { useMap } from '../Map';
import { SidebarPanel } from '../components/Sidebar/SidebarPanel';
import { SwitchCheckbox } from '../components/Form/SwitchCheckbox';
import { PoiMarker } from '../components/Map/PoiMarker';

import { useStore } from '../stores';
import { Layers } from '../stores/layers';
import { useTranslateFunction } from '../helpers/useTranslationHook';

export const Filter = observer(() => {
  const { t } = useTranslateFunction(Layers.filter);
  const { config, layers, categories, poi } = useStore();
  const map = useMap();

  return (
    <SidebarPanel
      isOpen={layers.activeLayer === Layers.filter}
      title={t('headline')}
      closeAction={layers.closeLayer}
      icons={config.icons}
      titleBarContent={<MultiSelectButton />}
    >
      <ul className="p-0 h-full overflow-auto list-none">
        {categories.list.map((category) => (
          <li
            className="relative py-3 px-4 border-b border-neutral-200"
            key={category.name}
          >
            <PoiMarker
              category={category}
              className="!absolute top-[7px] left-[15px]"
            />
            <SwitchCheckbox
              label={t(category.name)}
              isChecked={category.selected}
              onChange={async () => {
                await category.toggleSelection();
                await poi.clear();
                poi.fetch(map?.getBounds());
              }}
            />
          </li>
        ))}
      </ul>
    </SidebarPanel>
  );
});

const MultiSelectButton = () => {
  const { t } = useTranslateFunction(Layers.filter);

  const { categories, poi } = useStore();
  const map = useMap();

  return categories.allSelected() ? (
    <button
      onClick={() => {
        categories.deselectAll();
        poi.fetch(map?.getBounds());
      }}
    >
      {t('deselect_all')}
    </button>
  ) : (
    <button
      onClick={() => {
        categories.selectAll();
        poi.fetch(map?.getBounds());
      }}
    >
      {t('select_all')}
    </button>
  );
};
